<template>
  <div class="chapter-detail">
    <van-swipe ref="swipe" class="swipe" @change="onChange" :loop="false">
      <van-swipe-item v-for="item in list" :key="item.id">
        <section class="bg-index">
          <van-image class="bg" :src="item.bigImageUrl" fit="cover" alt="背景图" />
        </section>
        <section class="content">
          <div class="title-menu">
            <h3 class="title">{{ item.title }}</h3>
            <van-image class="menu" :src="require('@/assets/imgs/course/menu.png')" @click="showMenu"></van-image>
          </div>
          <div class="detail">{{ item.synopsis }}</div>
        </section>
        <!-- <section class="player">
          <AudioCustomize :src="item.audioSrc" :title="item.title" :index="index" :current="current" />
        </section> -->
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/{{ list.length }}</div>
      </template>
    </van-swipe>

    <van-popup v-model="isMenuShow" position="bottom" class="bottom-popup">
      <van-list>
        <van-cell v-for="(item, index) in list" :key="item.id" @click="changeChapter(index)">
          <van-image class="bitmap" :src="item.smallImageUrl" />
          <span class="chapter-title ell-1">{{ item.title }}</span>
        </van-cell>
      </van-list>
    </van-popup>
  </div>
</template>

<script>
import { chapterList } from '@/services';

export default {
  data() {
    return {
      id: '',
      isMenuShow: false,
      current: 0,
      list: [],
      audioSrc: ''
    };
  },

  mounted() {
    this.id = this.$route.query.id;
    this.getChapterDetail();
  },
  methods: {
    async getChapterDetail() {
      const params = { id: this.id };
      const res = await chapterList(params);
      this.list = res.dataList;
    },

    onChange(index) {
      this.current = index;
    },
    showMenu() {
      this.isMenuShow = true;
    },
    changeChapter(index) {
      this.isMenuShow = false;
      this.$refs.swipe.swipeTo(index);
    }
  }
};
</script>

<style lang="less" scoped>
.chapter-detail {
  min-height: 100vh;
  background-color: white;
  position: relative;
  .swipe {
    position: relative;
    height: 100vh;
    .custom-indicator {
      position: absolute;
      top: 12px;
      right: 12px;
      background-color: rgba(51, 51, 51, 0.5);
      padding: 6px 12px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .bg-index {
    .bg {
      width: 100%;
      height: 240px;
    }
  }
  .content {
    width: 100%;
    flex: 1;
    // display: flex;
    padding: 20px 16px;
    .title-menu {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 12px;
      .title {
        font-size: 21px;
        font-weight: 500;
        color: #262626;
        line-height: 24px;
      }
      .menu {
        width: 20px;
        height: 20px;
      }
    }
    .detail {
      flex: 1;
      font-size: 14px;
      font-weight: 400;
      color: #595959;
      line-height: 24px;
      overflow: auto;
    }
  }
  .bitmap {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  .bottom-popup {
    border-radius: 8px 8px 0px 0px;
  }

  .player {
    width: 100%;
  }
}
</style>

<style lang="less">
.chapter-detail {
  .bottom-popup {
    .van-cell {
      padding: 12px 16px;
      .van-cell__flexrow {
        height: 24px;

        .van-cell__value {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .chapter-title {
          font-size: 14px;
          font-weight: 400;
          color: #262626;
          line-height: 16px;
        }
      }
    }
  }
  .swipe {
    .van-swipe-item {
      overflow: scroll;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
